import {
  Button,
  ButtonSize,
  ButtonStyles,
  useTranslation,
  Theme,
  useNextgenRouter,
  NextgenImage,
  LoaderType,
} from '@nextgen-web-framework/all';
import { CartRoutePaths } from '@commerce-cart-webcomponents/sdk';
import styles from './EmptyCart.module.scss';

/**
 * Empty Cart Page
 * @public EmptyCart
 * @public EmptryCartProps
 * @param {EmptyCartProps} props {@link EmptyCartProps} - Props for cart total component
 *
 * # props example
 * ```ts
 * props: {
 * clickContinueShopping: fn
  }
 * ```
 * @example ./EmptyCart.md
 * @see {@link https://www.figma.com/file/rBlXYti8XPJWyvIYSEh6St/Ready-for-Dev---Alpha-2.0-%7C-Cart%2C-Checkout-%26-Payment?node-id=1%3A61&t=0GmHYhpVkBPAecsH-0}
 * @returns JSX HTML
 *
 */
export const EmptyCart = () => {
  const t = useTranslation();
  const router = useNextgenRouter();
  const continueShoppingHandler = () => {
    router.push && router.push(CartRoutePaths.HOME);
  };

  return (
    <div className={styles['empty-cart-component']}>
      <div className={styles['empty-cart-component-icon']}>
        <NextgenImage
          loaderType={LoaderType.WEBFONTS}
          src="/icons/EmptyCartIcon.svg"
          alt={'Empty cart icon'}
          isRelativeURL={true}
        />
      </div>
      <div className={styles['empty-cart-component-txt1']} data-testid="empty-cart-component-txt1">
        {t('cart.emptyCart.cartEmptyTxt1')}
      </div>
      <div className={styles['empty-cart-component-txt2']} data-testid="empty-cart-component-txt2">
        {t('cart.emptyCart.cartEmptyTxt2')}
      </div>

      <div className={styles['empty-cart-component-shopping-btn']}>
        <Button
          id="empty-cart-component-continue-shopping-btn"
          onClick={continueShoppingHandler}
          title={t('cart.emptyCart.cartEmptyBtnLabel')}
          tabIndex={0}
          buttonStyle={ButtonStyles.SOLID}
          theme={Theme.BLACK}
          size={ButtonSize.SMALL}
          role="button"
          data-testid="empty-cart-component-continue-shopping-btn"
          aria-label="empty-cart-component-continue-shopping-btn"
        />
      </div>
    </div>
  );
};
